import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { OauthAEMConfig } from '../../../models';
import {
  SubmitUserRegistration,
  SubmitUserRegistrationPayload,
  UserRegistrationInfo
} from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class SubmitUserInformationService {
  submitUserInformationHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.registerUser+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  submitUserInformation = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    password: string,
    fieldValues: UserRegistrationInfo
  ): Observable<SubmitUserRegistration> => {
    const getSubmitUserInformationUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const submitUserInformationUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getSubmitUserInformationUrl
      }
    ];

    const payload: SubmitUserRegistrationPayload = {
      password: password,
      fieldValues: fieldValues
    };

    return new ApiBuilder<
      SubmitUserRegistrationPayload,
      SubmitUserRegistration
    >(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(submitUserInformationUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.submitUserInformationHeader)
      .errorHandler(this._errorHandler)
      .library('SUBMIT_USER_REGISTRATION')
      .withCredentials(true)
      .create();
  };
}
